'use client';

import { useEffect } from 'react';

import { useAuth } from '@/lib/auth/AuthProvider';

import { setHandbookEventsViewer } from './handbookEvents';

export function useHandbookEventsViewer() {
  const { status, session } = useAuth();
  const staff = Boolean(session?.user?.roles?.includes('admin'));
  const countingDisabled = Boolean(session?.profile?.isTrackingDisabled);

  useEffect(() => {
    if (status === 'loading') return;
    setHandbookEventsViewer({ staff, countingDisabled });
  }, [countingDisabled, staff, status]);
}
